import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '');
      const scrollToAnchor = () => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return true;
        }
        return false;
      };

      if (!scrollToAnchor()) {
        const timeout = setTimeout(() => {
          if (!scrollToAnchor()) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
        }, 100);
        return () => clearTimeout(timeout);
      }
      return undefined;
    }

    window.scrollTo({ top: 0, behavior: 'smooth' });
    return undefined;
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
